// eslint-disable-next-line import/newline-after-import
import { message, Modal } from 'antd';
interface ErrorList {
    rule: string;
    field: string;
    message: string;
}
interface ErrorRelationship extends ErrorList {
    referenceTable: string;
    table: string;
    extraInfo?: any;
    getExtraInfo?: (extraInfo: any) => string;
}
const handleGenericError = () => {
    message.error(
        'Um erro desconhecido aconteceu, tente novamente mais tarde.',
    );
};

const ERROR_RELATIONSHIP_LIST: ErrorRelationship[] = [
    {
        rule: 'hasRelationship',
        field: 'id',
        referenceTable: 'planograms',
        table: 'product',
        message:
            'Este produto está vinculado a um ou mais planogramas e não pode ser excluído.',
    },
    {
        rule: 'hasRelationship',
        field: 'id',
        referenceTable: 'products',
        table: 'category',
        message:
            'Esta categoria está vinculada a um ou mais produtos e não pode ser excluída.',
    },
    {
        rule: 'hasRelationship',
        field: 'id',
        referenceTable: 'products',
        table: 'provider',
        message:
            'Este fornecedor está vinculado a um ou mais produtos e não pode ser excluído.',
    },
    {
        rule: 'hasRelationship',
        field: 'id',
        referenceTable: 'purchases',
        table: 'provider',
        message:
            'Este fornecedor está vinculado a uma ou mais compras e não pode ser excluído.',
    },
    {
        rule: 'hasRelationship',
        field: 'id',
        referenceTable: 'transfers',
        table: 'planograms',
        message:
            'Este planograma está vinculado a uma transferência com status "pendente" e não pode ser excluído.',
        getExtraInfo(extraInfo: {
            planogram_code: string;
            product_name: string;
        }) {
            const message =
                `${this.message}\n\n` +
                ` - CÓDIGO DE PLANOGRAMA: [${extraInfo.planogram_code}]\n` +
                ` - PRODUTO: [${extraInfo.product_name}]`;
            return message;
        },
    },
];

const ERROR_LIST: ErrorList[] = [
    {
        rule: 'unique',
        field: 'name',
        message: 'Nome já cadastrado',
    },
    {
        rule: 'unique',
        field: 'corporateName',
        message: 'Razão social já cadastrada',
    },
    {
        rule: 'unique',
        field: 'cnpj',
        message: 'CNPJ já cadastrado',
    },
    {
        rule: 'unique',
        field: 'cpf',
        message: 'CPF já cadastrado',
    },
    {
        rule: 'unique',
        field: 'email',
        message: 'E-mail já cadastrado',
    },
    {
        rule: 'required',
        field: 'provider_id',
        message: 'Possui produtos cadastrados',
    },
    {
        rule: 'required',
        field: 'shopmanager_id',
        message: 'Acesso proibido',
    },
    {
        rule: 'required',
        field: 'image',
        message: 'Imagem obrigatória',
    },
    {
        rule: 'required',
        field: 'token',
        message: 'Erro ao validar seu token',
    },
    {
        rule: 'required',
        field: 'email',
        message: 'E-mail obrigatório',
    },
    {
        rule: 'required',
        field: 'token',
        message: 'Token obrigatório',
    },
    {
        rule: 'requiredIfExists',
        field: 'pix',
        message: 'Pix é obrigatório quando existe "Tipo de Chave Pix"',
    },
    {
        rule: 'requiredIfExists',
        field: 'typePix',
        message: 'Tipo de chave pix é obrigatório quando existe "Pix"',
    },
    {
        rule: 'enum',
        field: 'type',
        message: 'Tipo inválido',
    },
    {
        rule: 'enum',
        field: 'inventory',
        message: 'Inventário inválido',
    },
    {
        rule: 'minLength',
        field: 'products',
        message: 'Lista de produtos deve ser maior que 0',
    },

    {
        rule: 'range',
        field: 'latitude',
        message: 'Latitude deve estar entre -90 e 90',
    },
    {
        rule: 'range',
        field: 'longitude',
        message: 'Longitude deve estar entre -180 e 180',
    },
    {
        rule: 'minLength',
        field: 'phone',
        message: 'Telefone precisa ter 11 digitos',
    },
    {
        rule: 'file',
        field: 'image',
        message: 'Selecione uma imagem válida',
    },
    {
        rule: 'validCPF',
        field: 'cpf',
        message: 'CPF inválido',
    },
    {
        rule: 'validCNPJ',
        field: 'cnpj',
        message: 'CNPJ inválido',
    },
    {
        rule: 'validCNPJ',
        field: 'doc',
        message: 'CNPJ inválido',
    },
    {
        rule: 'validCPF',
        field: 'doc',
        message: 'CPF inválido',
    },
    {
        rule: 'unique',
        field: 'stateInscription',
        message: 'Inscrição estadual já cadastrada',
    },
    {
        rule: 'validCPF',
        field: 'managingPartners.0.document',
        message: 'CPF do contratante inválido',
    },
    {
        rule: 'validCPF',
        field: 'managingPartners.1.document',
        message: 'CPF do Primeiro Sócio inválido',
    },
    {
        rule: 'validCPF',
        field: 'managingPartners.2.document',
        message: 'CPF do Segundo Sócio inválido',
    },
    {
        rule: 'required',
        field: 'managingPartners.1.address.city',
        message: 'Endereço completo do Primeiro Sócio obrigatório',
    },
    {
        rule: 'required',
        field: 'managingPartners.1.address.state',
        message: 'Endereço completo do Primeiro Sócio obrigatório',
    },
    {
        rule: 'required',
        field: 'managingPartners.1.address.district',
        message: 'Endereço completo do Primeiro Sócio obrigatório',
    },
    {
        rule: 'required',
        field: 'managingPartners.1.address.zipcode',
        message: 'Endereço completo do Primeiro Sócio obrigatório',
    },
    {
        rule: 'required',
        field: 'managingPartners.1.address.street',
        message: 'Endereço completo do Primeiro Sócio obrigatório',
    },
    {
        rule: 'required',
        field: 'managingPartners.1.address.number',
        message: 'Endereço completo do Primeiro Sócio obrigatório',
    },
    {
        rule: 'required',
        field: 'managingPartners.2.phone',
        message: 'Preencha todos os campos do Segundo Sócio',
    },
    {
        rule: 'required',
        field: 'managingPartners.2.email',
        message: 'Preencha todos os campos do Segundo Sócio',
    },
    {
        rule: 'required',
        field: 'managingPartners.2.document',
        message: 'Preencha todos os campos do Segundo Sócio',
    },
    {
        rule: 'required',
        field: 'managingPartners.2.name',
        message: 'Preencha todos os campos do Segundo Sócio',
    },
    {
        rule: 'file.size',
        field: 'image',
        message: '',
    },
    {
        rule: 'file.extname',
        field: 'image',
        message: '',
    },
    {
        rule: 'exists',
        field: 'storeIds.0',
        message:
            'Uma ou mais lojas selecionadas são inválidas. Verifique e tente novamente.',
    },
    {
        rule: 'exists',
        field: 'licenseTypeId',
        message: 'Tipo de licença não encontrado.',
    },
];

const handleRelationshipErrors = (error: ErrorRelationship) => {
    let messageError =
        'Um erro desconhecido ocorreu ao tentar excluir este registro.';

    const { referenceTable, table, extraInfo } = error;
    const errorInfo = ERROR_RELATIONSHIP_LIST.find(
        (errorFromList) =>
            errorFromList.referenceTable === referenceTable &&
            errorFromList.table === table,
    );
    if (extraInfo && errorInfo?.getExtraInfo) {
        messageError = errorInfo.getExtraInfo(extraInfo);
    } else if (errorInfo) {
        const { message } = errorInfo;
        messageError = message;
    }
    showModalError(messageError);
};

const showModalError = (message: string) => {
    Modal.error({
        title: 'Erro ao tentar excluir...',
        content: message,
        okText: 'Entendi',
        width: '50vw',
        styles: {
            body: { whiteSpace: 'pre-line' },
        },
        okButtonProps: {
            className: 'default-btn',
            style: {
                width: '30%',
                minWidth: '100px',
                float: 'right',
            },
        },
    });
};

function translateField(field: string): string {
    const translations: Record<string, string> = {
        icmsTaxSituation: 'Situação Tributária do ICMS',
    };
    return translations[field] || field;
}

const parseRawMessageError = (rawMessage: string): string | null => {
    if (
        rawMessage?.includes('Duplicate entry') &&
        rawMessage?.includes('stores_name_unique')
    ) {
        const match = rawMessage.match(/Duplicate entry '([^']+)'/);
        return match
            ? `O nome "${match[1]}" já está cadastrado para outra loja.`
            : 'Nome da loja já cadastrado.';
    }
    if (rawMessage?.includes('Duplicate entry')) {
        return 'Este registro já existe no sistema.';
    }
    return null;
};

export const errorsListing = (
    errors: ErrorRelationship[] | { message: string } | undefined | null,
): void => {
    if (!errors) {
        handleGenericError();
        return;
    }
    if (
        typeof errors === 'object' &&
        !Array.isArray(errors) &&
        typeof (errors as { message?: string }).message === 'string'
    ) {
        const msg = (errors as { message: string }).message;
        const friendly = parseRawMessageError(msg);
        message.error(friendly || 'Um erro ocorreu. Tente novamente.');
        return;
    }
    const receivedErrors = (Array.isArray(errors) ? errors : []).filter(
        (receivedError) => receivedError?.rule,
    );

    receivedErrors.forEach((receivedError) => {
        if (receivedError.rule === 'hasRelationship') {
            handleRelationshipErrors(receivedError);
            return;
        }

        if (receivedError.rule === 'enum') {
            const translatedField = translateField(receivedError.field);
            const choices = (receivedError as any)?.args?.choices?.join(', ');
            return message.error(
                `${translatedField} falhou na validação. Opções válidas: ${choices}.`,
            );
        }

        const isError = ERROR_LIST.filter((listedError) => {
            if (
                receivedError.rule === listedError.rule &&
                (receivedError.field === listedError.field ||
                    receivedError.field.startsWith(`${listedError.field}.`))
            ) {
                return message.error({
                    content: listedError.message || receivedError.message,
                    key: 'listed-error',
                });
            }
        });

        if (!isError.length) {
            return message.error({
                content:
                    'Um erro desconhecido aconteceu, tente novamente mais tarde.',
                key: 'generic-error',
            });
        }
    });
    if (!receivedErrors.length) {
        for (const errObj of Array.isArray(errors) ? errors : []) {
            for (const field in errObj) {
                if (!Object.prototype.hasOwnProperty.call(errObj, field))
                    continue; // eslint-disable-line no-continue
                const match = field.match(/^data\.(\d+)\./);
                if (match) {
                    const line = parseInt(match[1]) + 3;
                    const fieldErr = (
                        errObj as unknown as Record<string, string[]>
                    )[field];
                    if (
                        fieldErr?.some((msg) =>
                            msg.toLowerCase().includes('url'),
                        )
                    ) {
                        message.error(`Linha (${line}) URL da Imagem inválida`);
                        return;
                    }
                }
            }
        }
        handleGenericError();
    }
};

export const handleErrors = (statesErrors: any[]): void => {
    const requestErrors = statesErrors
        .filter((error) => !!error)
        .map((error) => {
            if (error?.response?.data?.errors) {
                const { errors } = error?.response?.data;

                return errors;
            }
            return [];
        });
    requestErrors.forEach((requestError) => {
        if (requestError.length > 0) errorsListing(requestError);
        else
            message.error(
                'Um erro desconhecido aconteceu, tente novamente mais tarde.',
            );
    });
};

export const clearErrors = (): void => {
    message.destroy();
    Modal.destroyAll();
};
